var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileEuro = function SvgFileEuro(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "file_euro_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#file_euro_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.375 8.918v15.697q0 .948-.656 1.604a2.18 2.18 0 0 1-1.604.656H7.885a2.18 2.18 0 0 1-1.604-.656 2.18 2.18 0 0 1-.656-1.604V5.385q0-.947.656-1.604a2.18 2.18 0 0 1 1.604-.656h10.697zm-7.93 4.832q-1.576 0-2.8.872a5.13 5.13 0 0 0-1.796 2.253H10.82a.8.8 0 0 0-.579.241.8.8 0 0 0-.241.58q0 .338.241.578a.8.8 0 0 0 .58.242h.742a6 6 0 0 0-.02.351q-.006.21.02.378h-.743a.8.8 0 0 0-.579.24.8.8 0 0 0-.241.58q0 .339.241.58a.8.8 0 0 0 .58.24h1.028q.533 1.498 1.777 2.311 1.244.815 2.82.815.859 0 1.608-.261.749-.26 1.412-.73a.64.64 0 0 0 .28-.513.7.7 0 0 0-.227-.567.88.88 0 0 0-.593-.267 1.1 1.1 0 0 0-.645.163q-.416.26-.879.397a3.561 3.561 0 0 1-2.571-.241 2.72 2.72 0 0 1-1.172-1.106h2.37q.338 0 .58-.241a.8.8 0 0 0 .24-.58.8.8 0 0 0-.24-.58.8.8 0 0 0-.58-.24h-2.826a2 2 0 0 1-.026-.339q0-.182.026-.39h2.825q.34 0 .58-.242a.8.8 0 0 0 .24-.579.8.8 0 0 0-.24-.579.8.8 0 0 0-.58-.241h-2.304q.365-.625 1.113-1.055a3.2 3.2 0 0 1 1.608-.43q.496 0 .957.13.462.131.88.391.299.183.644.17a.86.86 0 0 0 .593-.26.7.7 0 0 0 .227-.574.65.65 0 0 0-.28-.52 6 6 0 0 0-1.412-.716 4.9 4.9 0 0 0-1.609-.261m1.2-5.024q0 .48.324.805.325.325.805.324H22.5L17.645 5z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileEuro);
export default ForwardRef;